







import { defineComponent, reactive } from '@vue/composition-api';

interface Tag {
	Url: string;
	Weight: string;
	Name: string;
	LastUsed: string;
	Count: number;
}

export default defineComponent({
	props: {
		sort: {
			type: String as () => 'entrycount' | 'alphabetic' | 'lastused',
			required: true,
		},
		tags: {
			type: String,
			required: true,
		},
	},
	setup(props) {
		const state = reactive<{ tags: Tag[] }>({
			tags: JSON.parse(props.tags),
		});

		state.tags.sort((a, b) => {
			const valueA =
				props.sort === 'entrycount'
					? a.Count
					: props.sort === 'alphabetic'
					? b.Name.toUpperCase()
					: Date.parse(a.LastUsed);
			const valueB =
				props.sort === 'entrycount'
					? b.Count
					: props.sort === 'alphabetic'
					? a.Name.toUpperCase()
					: Date.parse(b.LastUsed);
			return valueA > valueB ? -1 : valueA < valueB ? 1 : 0;
		});
		return { state };
	},
});
